import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { RestService } from 'src/app/services/rest.service';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-edit-order',
  templateUrl: './edit-order.component.html',
  styleUrls: ['./edit-order.component.css'],
})
export class EditOrderComponent implements OnInit {
  orderProductsForEditing: any;
  currentProductForm: FormGroup | any;
  orderDetails: any;
  orderAddressForEditing: any;
  clientAddressIdSelected: any;
  orderFees: any;
  clientIdForAddress: any;
  currentProductAmountControls: FormControl[] = [];
  order_arr: any = [];
  clientName: any;
  packagesArr: any = [];
  product_arr: any;
  cancelButtonStatus = false;
  packImageStatus = true;
  catName: any;
  packageName: any;
  ifPackage = false;
  package_arr: any;
  packageID: any;
  arrayChoicePackage: any = [];
  arrayOfPackages: any = [];
  packageQuantity: any;
  orderPackagesForEditing: any;
  currentPackageAmountControls: FormControl[] = [];
  status_prod = false;
  ifProd = false;
  prod_arr: any;
  cat_arr: any;
  prodID: any;
  prodName: any;
  Quantity: any;
  arrayChoiceProduct: any = [];
  arrayOfProductPackages: any = [];
  orderPhoneNumber: any;
  clientAddress: FormGroup | any;
  showAddingNewAddressForm: boolean = false;
  showChangingAddress: boolean = false;
  clientAddressForUpdatingAddress: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UserProfileComponent>,
    private rest: RestService
  ) {}

  ngOnInit() {
    this.getData();
    this.getDataForEditModel();
    this.phoneNumberForm();
  }

  getData() {
    this.rest
      .orderDetails(this.data?.token, this.data?.orderId)
      .subscribe((res: any) => {
        this.orderDetails = res;
        this.orderPhoneNumber = this.orderDetails?.phone_number;

        this.phoneNoForm.patchValue({
          phoneNumber: this.orderPhoneNumber,
        });

        this.orderProductsForEditing = res?.OrdersProducts;
        this.orderPackagesForEditing = res?.packages;
        this.orderAddressForEditing = res?.address;
        this.clientAddressIdSelected = this.orderAddressForEditing?.id;
        this.orderFees = this.orderDetails?.fees;
        this.clientIdForAddress = res?.client?.id;

        this.orderProductsForEditing.forEach((item: any, index: number) => {
          const control = new FormControl(item.ammount);
          this.currentProductForm.addControl('currentProductAmount' + index, control);
          this.currentProductAmountControls.push(control);
        });

        this.orderPackagesForEditing.forEach((item: any, index: number) => {
          const control = new FormControl(item.ammount);
          this.currentProductForm.addControl('currentPackageAmount' + index, control);
          this.currentPackageAmountControls.push(control);
        });

        this.order_arr.push(res);
        this.clientName = res?.client?.email;
        this.packagesArr = res?.packages;
        this.product_arr = res?.OrdersProducts;
        if (res.paid == true) {
          this.cancelButtonStatus = true;
        }
      });

    this.getCurrentOrderForm();
  }

  removeProduct(index: number) {
    this.orderProductsForEditing.splice(index, 1);
    this.currentProductAmountControls.splice(index, 1);
  }

  removePackage(index: number) {
    this.orderPackagesForEditing.splice(index, 1);
    this.currentPackageAmountControls.splice(index, 1);
  }

  getCurrentOrderForm() {
    this.currentProductForm = new FormGroup({
      currentProductAmount: new FormControl(null),
      currentPackageAmount: new FormControl(null),
    });
  }

  getCatId(item: any) {
    // this.rest.showSpinner();
    this.catName = item.name;
    this.status_prod = false;
    this.rest.catDetails(1, 10, item?.id).subscribe((res: any) => {
      // this.rest.hideSpinner();
      this.status_prod = true;
      if (res?.products?.length != 0) {
        this.ifProd = true;
        this.prod_arr = res?.products;
      } else {
        this.ifProd = false;
      }
    });
  }

  selectPackageFromList(item: any) {
    this.packageName = item?.name;
    this.packageID = item?.id;
    this.ifPackage = true;
  }

  choseProd(item: any) {
    this.prodID = item?.id;
    this.prodName = item?.name;
  }

  getDataForEditModel() {
    // this.rest.showSpinner();
    // Get category list
    this.rest.listCatOnly(this.data?.token).subscribe((res: any) => {
      this.cat_arr = res;
      // this.rest.hideSpinner();
    });

    // Get package list
    this.rest.allPackage().subscribe((res: any) => {
      this.package_arr = res;
    });
  }

  add() {
    this.arrayChoiceProduct.push({
      prodName: this.prodName,
      amount: this.Quantity,
    });
    this.arrayOfProductPackages.push({
      id: this.prodID,
      quantity: this.Quantity,
    });

    this.ifProd = false;
    this.status_prod = false;
    this.catName = '';
    this.prodName = '';
    this.Quantity = '';
  }

  addPackage() {
    this.arrayChoicePackage.push({
      packageName: this.packageName,
      amount: this.packageQuantity,
    });
    this.arrayOfPackages.push({
      id: this.packageID,
      amount: this.packageQuantity,
    });

    this.ifPackage = false;
    this.packageName = '';
    this.packageName = '';
    this.packageQuantity = '';
  }

  changeAddress() {
    this.getClientAddress();
    this.showChangingAddress = true;
  }

  getClientAddress() {
    // this.rest.showSpinner();

    this.rest
      .getUserAddress(this.data.token, this.clientIdForAddress)
      .subscribe((res) => {
        // this.rest.hideSpinner();

        this.clientAddressForUpdatingAddress = res;
      });
  }

  selectAddress(addressId: any) {
    this.clientAddressIdSelected = addressId;
  }

  addNewAddress() {
    this.addNewAddressForm();
    this.showAddingNewAddressForm = true;
    this.showChangingAddress = false;
  }

  addNewAddressForm() {
    this.clientAddress = new FormGroup({
      address: new FormControl('', [Validators.required]),
      governorate: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      client_id: new FormControl(this.clientIdForAddress),
    });
  }

  saveAddress() {
    this.showAddingNewAddressForm = false;
    this.showChangingAddress = true;
    this.rest
      .addNewAddress(this.clientAddress.value, this.data.token)
      .subscribe(() => {
        this.rest.successToast('toast.address_added');
      });

    setTimeout(() => {
      this.getClientAddress();
    }, 100);
  }

  backToClientAddressList() {
    this.showAddingNewAddressForm = false;
    this.showChangingAddress = true;
  }

  closePrompt() {
    this.showChangingAddress = false;
    this.showAddingNewAddressForm = false;
    this.arrayChoiceProduct = [];
    this.ifProd = false;
    this.status_prod = false;
    this.catName = null;
  }

  //Phone number Form
  phoneNoForm: FormGroup | any;
  phoneNumberForm() {
    this.phoneNoForm = new FormGroup({
      phoneNumber: new FormControl('', [
        Validators.required,
        this.phoneNumberValidator,
      ]),
    });
  }
  //Phone number Form

  save() {
    // Read live form control values at save time — avoids stale (change)-event data
    const existingProducts = this.orderProductsForEditing
      .map((item: any, i: number) => ({
        id: item?.ordersproducts?.id,
        quantity: Number(this.currentProductAmountControls[i]?.value) || 0,
      }))
      .filter((p: any) => p.quantity > 0);

    const existingPackages = this.orderPackagesForEditing
      .map((item: any, i: number) => ({
        id: item?.orderspackages?.id,
        amount: Number(this.currentPackageAmountControls[i]?.value) || 0,
      }))
      .filter((p: any) => p.amount > 0);

    const obj = {
      id: this.data?.orderId,
      address_id: this.clientAddressIdSelected,
      cashed: this.orderDetails?.cashed,
      products: [...this.arrayOfProductPackages, ...existingProducts],
      packages: [...this.arrayOfPackages, ...existingPackages],
      fees: this.orderFees,
      phone_number: this.phoneNoForm.get('phoneNumber').value,
    };

    this.rest.editOrder(this.data.token, obj).subscribe({
      next: (res: any) => {
        this.order_arr = [];
        this.closePrompt();
        this.dialogRef.close(res.status);
      },
      error: (_err: any) => {
        this.rest.errorToaster('toast.error_generic');
      },
    });
  }

  phoneNumberValidator(control: AbstractControl): ValidationErrors | null {
    const phonePattern = /^[0-9]{11}$/;
    const value = control.value;

    if (!value) {
      return null; // Allow empty value
    }

    if (phonePattern.test(value)) {
      return null; // Validation passes
    } else {
      return { invalidEmailOrPhone: true }; // Validation fails
    }
  }
}
